import { useMemo } from 'react';
import { useDatosApi } from './1_consultar_datos_api';
import { procesarFormulario } from '../utils/gruposSubgruposProcessor';

const ESTADISTICAS_VACIAS = {
  totalGrupos: 0,
  totalSubgrupos: 0,
  totalPreguntas: 0,
  nivelesMaximos: 0
};

/**
 * Paso 2: Crear grupos y subgrupos a partir de los datos del formulario
 * Procesa el array plano de preguntas en un árbol de grupos/subgrupos y calcula
 * sus estadísticas en un único paso puro (procesarFormulario ya hace ambas cosas
 * recursivamente); no hay estado ni efectos aquí, solo derivación memoizada.
 */
const CrearGruposSubgrupos = () => {
  const {
    datosFormulario,
    datosEstanCargados,
    estadoCarga
  } = useDatosApi();

  const { grupos: gruposProcesados, estadisticas: estadisticasGrupos } = useMemo(() => {
    if (!datosFormulario.preguntas || datosFormulario.preguntas.length === 0) {
      return { grupos: [], estadisticas: ESTADISTICAS_VACIAS };
    }

    return procesarFormulario(datosFormulario.preguntas);
  }, [datosFormulario.preguntas]);

  return {
    // Datos procesados
    gruposProcesados,
    estadisticasGrupos,

    // Estados de carga
    estadoCarga,
    datosEstanCargados: datosEstanCargados(),

    // Datos originales
    datosFormulario
  };
};

/**
 * Hook personalizado para usar los datos procesados de grupos y subgrupos
 * @returns {Object} Objeto con los datos procesados y funciones de utilidad
 */
export const useGruposSubgrupos = () => {
  return CrearGruposSubgrupos();
};

export default CrearGruposSubgrupos;
